import { api } from './instance'
import type { Alert } from '../types'

export const alertsApi = {
  getAlerts: async (): Promise<Alert[]> => {
    const { data } = await api.get('/alerts')
    return data
  },

  getAlertById: async (id: string): Promise<Alert> => {
    const { data } = await api.get(`/alerts/${id}`)
    return data
  },

  createAlert: async (alert: Omit<Alert, 'id' | 'createdAt' | 'updatedAt' | 'state' | 'lastStateChange' | 'lastEvaluatedAt' | 'lastEvaluatedValue'>): Promise<Alert> => {
    const { data } = await api.post('/alerts', alert)
    return data
  },

  updateAlert: async (id: string, updates: Partial<Alert>): Promise<Alert> => {
    const { data } = await api.put(`/alerts/${id}`, updates)
    return data
  },

  deleteAlert: async (id: string): Promise<void> => {
    await api.delete(`/alerts/${id}`)
  },

  testAlert: async (id: string): Promise<{ triggered: boolean; value: number }> => {
    const { data } = await api.post(`/alerts/${id}/test`)
    return data
  },
}
